import axios from 'axios';

import endpoints from '../endpoints';
import AuthService from '../../state/auth.service';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    getDetails(criterionId) {
        return axios
            .get(endpoints.CRITERION_BASE + '/' + criterionId, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    getStatuses() {
        return axios
            .get(endpoints.CRITERION_BASE + '/statuses', {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    updateCriterion(criterionId, criterionChanges) {
        return axios
            .put(
                endpoints.CRITERION_BASE + '/' + criterionId,
                criterionChanges,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },

    updateCriterionForOrganization(criterionId, criterionChanges) {
        return axios
            .put(
                endpoints.CRITERION_BASE + '/all/' + criterionId,
                criterionChanges,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },

    updateCheckin(criterionId, checkin) {
        return axios
            .put(
                endpoints.CRITERION_BASE + '/all/' + criterionId,
                {
                    checkin: checkin,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },

    updatePlanned(criterionId, planned) {
        return axios
            .put(
                endpoints.CRITERION_BASE + '/' + criterionId,
                {
                    planned: planned,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },

    updateStatus(criterionId, status) {
        return axios
            .put(
                endpoints.CRITERION_BASE + '/' + criterionId,
                {
                    status: status,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    updateComponentCount(criterionId, count) {
        return axios
            .put(
                endpoints.CRITERION_BASE + '/' + criterionId,
                {
                    components: count,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },
};
